module.exports = __webpack_public_path__ + "static/media/dummy-person-image.9a77ac29.jpg";